import { useCallback, useEffect, useMemo, useState } from 'react';

import { countChars } from 'src/lib/string';
import { useFreestyleToolsActions } from 'src/store';

const DEFAULT_ENTITY = {
  name: '',
  allInstructionsData: null,
  generationTool: null,
  allWorkspaces: false,
};

export const useEntityState = (
  freestyleToolContent,
  isFreestyleToolSaveViewVisible,
  generationTool
) => {
  const [entity, setEntity] = useState({});
  const freestyleToolsActions = useFreestyleToolsActions();

  useEffect(() => {
    if (!isFreestyleToolSaveViewVisible) {
      return;
    }

    const instructions = freestyleToolContent ? freestyleToolContent.allInstructionsData : null;

    setEntity({
      ...DEFAULT_ENTITY,
      name: freestyleToolContent?.name || '',
      allInstructionsData: instructions,
      generationTool,
    });
  }, [isFreestyleToolSaveViewVisible, freestyleToolContent, generationTool]);

  const handleNameChange = useCallback(
    (event) => {
      freestyleToolsActions.clearNameErrorMessage();
      setEntity((prev) => ({ ...prev, name: event.target.value }));
    },
    [setEntity, freestyleToolsActions]
  );

  const handlePromptChange = useCallback(
    (value, data) => {
      setEntity((prev) => ({ ...prev, allInstructions: value, allInstructionsData: data }));
    },
    [setEntity]
  );

  const handleToolChange = useCallback(
    (event) => {
      setEntity((prev) => ({ ...prev, generationTool: event.target.value }));
    },
    [setEntity]
  );

  const handleAllWorkspacesChange = useCallback(
    (event, checked) => {
      setEntity((prev) => ({ ...prev, allWorkspaces: checked }));
    },
    [setEntity]
  );

  const nameCounter = useMemo(
    () => ({
      value: entity ? countChars(entity.name) : 0,
      max: 60,
      strict: true,
    }),
    [entity]
  );

  return {
    entity,
    handleNameChange,
    handlePromptChange,
    nameCounter,
    handleToolChange,
    handleAllWorkspacesChange,
  };
};
